import React, { useState, useRef } from "react";
import { CalculatecompletedPercentage } from "../../Utils/CalculateCompletion";
import "./CalculateCompletion.scss";
import ProgressBar from "react-bootstrap/ProgressBar";
import OutsideClickHandler from "react-outside-click-handler";

function CalculateCompletion(props) {
  const ref = useRef();
  const [showSections, setShowSections] = useState(false);

  const calculatedData = CalculatecompletedPercentage(
    props && props.resumeFields
  );

  const handleSectionMissing = () => {
    setShowSections(!showSections);
  };

  const handleAddSection = (section) => {
    props.setSection(section, props.sectionType);
    const element = document.getElementsByClassName(`basic-scroll-${section}`);
    setTimeout(() => {
      if (element && element[0]) {
        element[0].scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest",
        });
      }
    }, 350);
  };

  const handleScrollSection = (section) => {
    const element = document.getElementsByClassName(`basic-scroll-${section}`);
    setTimeout(() => {
      if (element && element[0]) {
        element[0].scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest",
        });
      }
    }, 350);
  };

  const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  return (
    <>
      <div className="completion-percentage-wrapper">
        <div className="d-flex justify-content-between">
          <span className="completion-percentage-span">
            <span className="percentage-count">
              {calculatedData?.completedPercentage}%
            </span>{" "}
            Profile completeness
          </span>
          <span>
            {/* <span>hello</span> */}
            <i
              class="fa fa-question-circle cursor calculate-questionmark"
              aria-hidden="true"
              onClick={handleSectionMissing}
            ></i>
          </span>
        </div>
        <OutsideClickHandler
          onOutsideClick={(e, value) => {
            const parentWithClass = e.target.closest(".showSectionWrapper");
            const anotherParentWithClass = e.target.closest(
              ".calculate-questionmark"
            );
            if (
              showSections &&
              parentWithClass == null &&
              anotherParentWithClass == null
            ) {
              setShowSections(false);
            }
            // else if (formActive && anotherParentWithClass != "") {
            //   setFormActive(true);
            // }
          }}
        >
          {showSections && showSections && (
            <>
              <div className="showSectionWrapper">
                <div className="row">
                  {calculatedData &&
                    calculatedData.missingSections &&
                    calculatedData.missingSections.length > 0 && (
                      <>
                        {/* <p className="calculate-p">Missing Sections :</p> */}
                      </>
                    )}
                  {calculatedData?.missingFields?.map((resp) => (
                    <>
                      {resp && resp.fields && resp.fields.length > 0 && (
                        <>
                          <div className="col-md-6">
                            <p
                              className="calculate-subtext cursor"
                              onClick={() => handleScrollSection(resp.section)}
                            >
                              <span className="calculate-subtext-percent">
                                +{resp.score}%{" "}
                              </span>{" "}
                              Add Missing {capitalize(resp.section)}
                            </p>
                          </div>
                          {/* <p className=" calculate-text">
                              {" "}
                              {capitalize(resp.section)} :
                              
                            </p> */}
                          {/* {resp &&
                            resp.fields &&
                            resp.fields.map((secField) => (
                              <div className="col-md-6">
                                <p
                                  className="calculate-subtext cursor"
                                  onClick={() =>
                                    handleScrollSection(resp.section)
                                  }
                                >
                                  Add Missing {capitalize(secField)}
                                </p>
                              </div>
                            ))} */}
                        </>
                      )}
                    </>
                  ))}
                  {calculatedData?.missingSections?.map((res) => (
                    <>
                      <div className="col-md-6">
                        <p
                          className="calculate-subtext cursor "
                          onClick={() => handleAddSection(res.section)}
                        >
                          <span className="calculate-subtext-percent">
                            +{res.score}%{" "}
                          </span>{" "}
                          Add {capitalize(res.section)}
                        </p>
                      </div>
                    </>
                  ))}
                </div>
              </div>
            </>
          )}
        </OutsideClickHandler>
        <ProgressBar
          now={calculatedData?.completedPercentage}
          variant="success"
        />
      </div>
    </>
  );
}

export default CalculateCompletion;
